import React, {useState, useRef} from 'react';
import {Form, InputGroup} from "react-bootstrap";
import {Button} from "@gravity-ui/uikit";
import UserCard from "../../components/userCard/UserCard";
import {Eye, EyeSlash, Pencil} from "@gravity-ui/icons";
import PasswordButton from "../../components/passwordButton/PasswordButton";
import axios from "axios";
import {ALL_USERS_ENDPOINT, getAcceptAuthConfig} from "../../api/api";

function CreateUser() {
    const [submitting, setSubmitting] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const [formData, setFormData] = useState({
        email: "",
        // password: "",
        // re_password: "",
        last_name: "",
        first_name: "",
        middle_name: "",
        title: "",
        avatar: ""
    });

    const [errors, setErrors] = useState({
        email: "",
        // password: "",
        // re_password: "",
        last_name: "",
        first_name: "",
        middle_name: "",
        title: "",
        avatar: ""
    });

    const [selectedImage, setSelectedImage] = useState("");

    const onSubmit = (e) => {
        e.preventDefault();

        console.log("formData:")
        console.log(formData)

        const formDataToSend = new FormData();
        for (const key in formData) {
            console.log(key, formData[key])
            formDataToSend.append(key, formData[key]);
        }

        console.log("formDataToSend:")
        console.log(formDataToSend)

        axios
            .post(ALL_USERS_ENDPOINT, formDataToSend, getAcceptAuthConfig())
            .then(response => {
                window.location.reload();
                console.log("Пользователь создан");
            })
            .catch(error => {
                console.error('Не удалось создать пользователя:', error);
                setErrors(JSON.parse(error.response.request.response));
            })
            .finally(() => {
                setSubmitting(false);
            });

        console.log("submit");
        console.log(formData);
    };

    const filePicker = useRef(null);

    const onPick = () => {
        filePicker.current.click();
    };

    const onChange = (e) => {
        setFormData((prevData) => ({
            ...prevData,
            [e.target.name]: e.target.value
        }));
    };

    const onChangeAvatar = (e) => {
        setFormData((prevData) => ({
            ...prevData,
            [e.target.name]: e.target.files[0]
        }));

        setSelectedImage(URL.createObjectURL(e.target.files[0]))

        console.log("onChangeAvatar");
        console.log(e.target);
        console.log(e.target.value);
        console.log(e.target.name, e.target.files[0]);
    };

    return (
        <>
            <h3 className="mb-2">Создание пользователя</h3>
            <hr className="clearfix w-100 pb-0"/>
            <Form onSubmit={onSubmit}>
                <div className="row d-flex flex-column-reverse flex-lg-row">
                    <div className="col-lg-9 mt-lg-0 mt-3">
                        <Form.Group controlId="formEmail" className="mb-3">
                            <Form.Label className="required">Электронная почта</Form.Label>
                            <Form.Control required type="email" name="email"
                                          value={formData.email} onChange={onChange}
                                          isInvalid={!!(errors && errors.email)}/>
                            <Form.Control.Feedback type="invalid">{errors && errors.email}</Form.Control.Feedback>
                        </Form.Group>

                        {/*<Form.Group controlId="formPasssword" className="mb-3">*/}
                        {/*    <Form.Label className="required">Пароль</Form.Label>*/}
                        {/*    <Form.Control*/}
                        {/*        type={showPassword ? 'text' : 'password'}*/}
                        {/*        name="password"*/}
                        {/*        value={formData.password}*/}
                        {/*        onChange={onChange}*/}
                        {/*        isInvalid={!!(errors && errors.password || errors && errors.non_field_errors)}*/}
                        {/*        required*/}
                        {/*    />*/}
                        {/*    <Form.Control.Feedback*/}
                        {/*        type="invalid">{errors && errors.password}</Form.Control.Feedback>*/}
                        {/*</Form.Group>*/}

                        {/*<Form.Group controlId="formRePasssword" className="mb-3">*/}
                        {/*    <Form.Label className="required">Повторите пароль</Form.Label>*/}
                        {/*    <InputGroup>*/}
                        {/*        <Form.Control*/}
                        {/*            type={showPassword ? 'text' : 'password'}*/}
                        {/*            name="re_password"*/}
                        {/*            value={formData.re_password}*/}
                        {/*            onChange={onChange}*/}
                        {/*            isInvalid={!!(errors && errors.re_password || errors && errors.non_field_errors)}*/}
                        {/*            required*/}
                        {/*        />*/}
                        {/*        <PasswordButton onClick={toggleShowPassword}>*/}
                        {/*            {showPassword ? <EyeSlash/> : <Eye/>}*/}
                        {/*        </PasswordButton>*/}
                        {/*    </InputGroup>*/}
                        {/*    <Form.Control.Feedback type="invalid">*/}
                        {/*        {errors && errors.re_password || errors && errors.non_field_errors}*/}
                        {/*    </Form.Control.Feedback>*/}
                        {/*</Form.Group>*/}

                        <Form.Group controlId="formLastname" className="mb-3">
                            <Form.Label className="required">Фамилия</Form.Label>
                            <Form.Control required type="text" name="last_name" value={formData.last_name}
                                          onChange={onChange}/>
                        </Form.Group>

                        <Form.Group controlId="formFirstname" className="mb-3">
                            <Form.Label className="required">Имя</Form.Label>
                            <Form.Control required type="text" name="first_name" value={formData.first_name}
                                          onChange={onChange}/>
                        </Form.Group>

                        <Form.Group controlId="formMiddlename" className="mb-3">
                            <Form.Label>Отчество</Form.Label>
                            <Form.Control type="text" name="middle_name" value={formData.middle_name}
                                          onChange={onChange}/>
                        </Form.Group>

                        <Form.Group controlId="formTitle" className="mb-3">
                            <Form.Label>Должность, место работы/учёбы</Form.Label>
                            <Form.Control as="textarea" type="text" name="title" value={formData.title}
                                          onChange={onChange}/>
                        </Form.Group>

                        <Button view="action" type="submit" disabled={submitting} className="mt-3 w-100" size="l">
                            {submitting ? 'Сохранение...' : 'Сохранить'}
                        </Button>
                    </div>
                    <div className="col-lg-3">
                        <Form.Label>Изображение профиля</Form.Label>
                        <Form.Control className="hidden" name="avatar" type="file" ref={filePicker} accept="image/*"
                                      onChange={onChangeAvatar}></Form.Control>
                        <div className="avatar-upload position-relative" role="button" onClick={onPick}>
                            <UserCard size="l" imgUrl={selectedImage}/>
                            <span className="avatar-upload__button">
                                <Pencil/> Изменить
                            </span>
                        </div>
                    </div>
                </div>
            </Form>
        </>
    );
}

export default CreateUser;